import React, { useState, useEffect } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { PrimaryIconButton, SecondaryIconButton } from '../../theme/index';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { modalAction, modalDeleteAction } from '../../redux/reducers/Modal';
import SuccessModal from '../SuccessModal';
import DangerModal from '../DangerModal';
import { Pagination, PaginationItem, Grid } from '@mui/material';
import styled from '@mui/material/styles/styled';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import axios from 'axios';
import { saveCategoryIdAction } from '../../redux/reducers/Delete';
import { collection, getDocs, query, where } from "firebase/firestore";
import db from "../../config/firebase";

const PaginationGrid = styled(Grid)(({ theme }) => `
    ul{
        justify-content: end
    }

    button:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)

const PaginationItemStyled = styled(PaginationItem)(({ theme }) => `
    svg{
        color: #000;
    }

    button:hover, svg:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)

function createData(id, name, status) {
    return { id, name, status};
  }

const rows = [
    createData(1, 'Matrimonial', true),
    createData(2, 'Personal', true),
    createData(3, 'Doble', true),
    createData(4, 'Junior Suite', true),
    createData(5, 'Suite', true),
  ];


const Levels = () => {

    const [ clients, setClients ] = useState([]);
    const [ search, setSearch ] = useState([]);
    const [ paginations, setPaginations ] = useState(0);
    const [ initResult, setInitResult ] = useState(0);
    const [ endResult, setEndResult ] = useState(10);
    const [ categoryData, setCategoryData ] = useState({});
    const searchData = useSelector( state => state.Search.data );
    const newCategoryData = useSelector( state => state.Create.category );
    const categoryToEdit = useSelector( state => state.Edit.categoryEdited );
    const categoryToDelete = useSelector( state => state.Delete.categoryId );
    const categoryStatusDelete = useSelector( state => state.Delete.categoryStatus );

    useEffect( () => {
        if (newCategoryData.name){
            let currentClients = [newCategoryData, ...clients];
            setClients(currentClients);
        }
    },[newCategoryData] )

    useEffect( () => {
        if(categoryToEdit !== {}){
            let listEdited = clients.map( item => {
                return (item.id == categoryToEdit.id) ? {...categoryToEdit} : item ;
            } );

            setClients(listEdited);
        }
    },[categoryToEdit] )

    useEffect( () => {
        if(categoryStatusDelete == 'SUCCESS'){
            const currentClients = clients.filter( item => item.id !== categoryToDelete);
            setClients(currentClients);
        }
    },[categoryStatusDelete] )

    const [page, setPage] = React.useState(1);
    const handleChange = (event, value) => {
        if( page < value ){
            // aumentar
            setInitResult(initResult+10);
            setEndResult(endResult+10);
        }else{
            // disminuir
            setInitResult(initResult-10);
            setEndResult(endResult-10);
        }
        setPage(value);
    };

    useEffect( () => {
        
        const petition = async () => {
            const q = query(collection(db, "category"));
            const querySnapshot = await getDocs(q);
            let categoryArray = [];
            querySnapshot.forEach((doc) => {
                categoryArray.push({id: doc.id, ...doc.data()});
            }); 
            addData(categoryArray);
        }

        const addData = data => {
            setClients(data.reverse());
        }

        petition();
        
    },[] );

    useEffect( () => {
        const textToSearch = searchData.toLowerCase();
        const mappingArray = rows.filter( (item, index) => {
            return ( index >= initResult && index < endResult ) ? item : null;
        } );
        
        if(searchData !== ''){
            const filteredElements = clients.filter( (item, index) => item.name.toLowerCase().includes(textToSearch)  );
            setSearch(filteredElements);
        }else{
            // const filteredElements = mappingArray.filter( (item, index) => item.name.toLowerCase().includes(textToSearch) );
            // setClients(filteredElements);
        }

        setPaginations(Math.ceil(rows.length/10))
    },[searchData, initResult, endResult] );

    const dispatch = useDispatch();
    const [ showModal, setShowModal ] = useState(false);
    const [ showDeleteModal, setShowDeleteModal ] = useState(false);
    const [ modalForm, setModalForm ] = useState('');
    const [ deleteModal, setDeleteModal ] = useState('');
    const modalStatus = useSelector( state => state.Modal.modalState );
    const deleteModalStatus = useSelector( state => state.Modal.deleteModalState );

    useEffect( () => {
        setShowModal(modalStatus);
        if (!modalStatus) setModalForm('')
    }, [modalStatus] );
    
    useEffect( () => {
        setShowDeleteModal(deleteModalStatus);
      }, [deleteModalStatus] );

    const editClient = (data) => {
        setModalForm('editCategory');
        setCategoryData(data);
        setDeleteModal('');
        dispatch(modalAction());
    }

    const deleteClient = (id) => {
        setModalForm('');
        dispatch(modalDeleteAction());
        setDeleteModal('category');
        dispatch(saveCategoryIdAction(id));
    }

  return (
    <>
        {
            (showModal && modalForm !== '' ) &&
            <SuccessModal view={modalForm} category={categoryData} />
        }
        {
            (showDeleteModal && deleteModal !== '' ) &&
            <DangerModal view={deleteModal} />
        }
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell align="center">Name</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">Acciones</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                { (searchData !== '') && search.map((row, index) => (
                    <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell component="th" scope="row">{row.id.substring(0, 5)}</TableCell>
                    <TableCell align="center">{row.name}</TableCell>
                    <TableCell align="center">{
                        (row.status === "true") ? 'Activado' : 'Desactivado'
                    }</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{
                        <>
                            <PrimaryIconButton aria-label="delete" sx={{ mx: '.4rem' }} onClick={ () => editClient(row) }>
                                <EditIcon />
                            </PrimaryIconButton>
                            <SecondaryIconButton aria-label="delete" onClick={ () => deleteClient(row.id) }>
                                <DeleteIcon />
                            </SecondaryIconButton>
                        </>
                    }</TableCell>
                    </TableRow>
                ))}


                { (searchData == '') && clients.map((row, index) => (
                    <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                    <TableCell component="th" scope="row">{row.id.substring(0, 5)}</TableCell>
                    <TableCell align="center">{row.name}</TableCell>
                    <TableCell align="center">{
                        (row.status === "true") ? 'Activado' : 'Desactivado'
                    }</TableCell>
                    <TableCell style={{ textAlign: 'center' }}>{
                        <>
                            <PrimaryIconButton aria-label="delete" sx={{ mx: '.4rem' }} onClick={ () => editClient(row) }>
                                <EditIcon />
                            </PrimaryIconButton>
                            <SecondaryIconButton aria-label="delete" onClick={ () => deleteClient(row.id) }>
                                <DeleteIcon />
                            </SecondaryIconButton>
                        </>
                    }</TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>

        <Grid container sx={{ justifyContent: 'end', textAlign: 'end', mt: 2 }}>
            <PaginationGrid item xs={12}>
                <Pagination
                    count={paginations}
                    onChange={handleChange}
                    renderItem={(item) => (
                        <PaginationItemStyled
                        components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                        />
                    )}
                />
            </PaginationGrid>
        </Grid>
    </>
  )
}

export default Levels